export default __webpack_public_path__ + "static/13-ef39601cdf6c558e43b54643c414268a.jpg";